import React from 'react'
import { generatePath, useNavigate, useParams } from 'react-router-dom'
import PropTypes from 'prop-types'

import Tabs from '~/components/Tabs'
import Divider from '~/components/Divider'
import * as ROUTES from '~/constants/routes'
import { LOT_SHEETS_DETAIL_TABS } from '~/constants/tabs'

const tabs = [
  { value: LOT_SHEETS_DETAIL_TABS.GENERAL, label: 'General' },
  { value: LOT_SHEETS_DETAIL_TABS.HISTORY, label: 'History' }
]

function LotSheetsDetailTabs ({ value }) {
  const { guid } = useParams()
  const navigate = useNavigate()

  const onChange = (event, tab) => {
    const redirect = generatePath(ROUTES.LOT_SHEETS_DETAIL_PATH, { guid, tab })
    navigate(redirect, { replace: true })
  }

  return (
    <>
      <Tabs
        tabs={tabs}
        value={value}
        onChange={onChange}
      />
      <Divider />
    </>
  )
}

LotSheetsDetailTabs.propTypes = {
  value: PropTypes.string.isRequired
}

export default LotSheetsDetailTabs
